import { useCallback } from "react";
import { useIntercom } from "./intercom";
import { useNavigation } from "@react-navigation/core";
import { RootStackParamList } from "../navigations/RootNavigation";
import { StackScreenProps } from "@react-navigation/stack";

type ScreenParams = StackScreenProps<RootStackParamList>;

const EXTERNAL_LINK_SCHEMES = ["http:", "https:", "mailto:", "sms:", "tel:"];

export const useOpenMarkdownLink = () => {
    const { presentArticleId } = useIntercom();
    const navigation = useNavigation<ScreenParams["navigation"]>();

    const openMarkdownLink = useCallback(
        (url: string) => {
            if (url.startsWith("intercom://")) {
                const articleId = url.split("intercom://")[1];
                void presentArticleId(articleId);

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                navigation.navigate(url);
                return false;
            }
            if (EXTERNAL_LINK_SCHEMES.some((scheme) => url.startsWith(scheme))) {
                return true;
            }

            return false;
        },
        [navigation, presentArticleId],
    );

    return openMarkdownLink;
};
